import React from 'react';
import { Alert, Chip, CircularProgress, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';

const list = (v) => (Array.isArray(v) ? v : []);

// The account's machines as VES lists them, with all of their labels and the rule sets that apply to each. Read only: which rules a
// machine gets follows from its labels, so it is changed by changing the labels in VES or the filter of a rule set.
function DevicesTab({ devices }) {
  if (!devices || devices.state === 'loading') return <Stack alignItems="center" sx={{ py: 6 }}><CircularProgress /></Stack>;
  if (devices.state === 'error') return <Alert severity="error">{devices.error}</Alert>;
  if (devices.devicesAvailable === false) return <Alert severity="warning">The machine list could not be read from VES just now.</Alert>;
  const rows = list(devices.devices);
  if (rows.length === 0) return <Typography variant="body2" color="text.secondary">VES lists no machines for this account.</Typography>;

  return (
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
        The machines VES lists for this account, with their labels and the rule sets whose filters match them. To change which rules a machine gets,
        change its labels in VES or the filter of a rule set.
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small" aria-label="Machines">
          <TableHead>
            <TableRow>{['Hostname', 'Device id', 'Labels', 'Rule sets that apply', 'Connection'].map((h) => <TableCell key={h} sx={{ fontWeight: 700 }}>{h}</TableCell>)}</TableRow>
          </TableHead>
          <TableBody>
            {rows.map((d) => (
              <TableRow key={d.deviceId} hover sx={{ verticalAlign: 'top' }}>
                <TableCell>{d.hostname}</TableCell>
                <TableCell>{d.deviceId}</TableCell>
                <TableCell>
                  <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
                    {Object.entries(d.labels || {}).map(([k, v]) => <Chip key={k} size="small" variant="outlined" label={`${k} is ${v}`} />)}
                  </Stack>
                </TableCell>
                <TableCell>
                  {list(d.ruleSets).length === 0 ? <Typography variant="caption" color="text.secondary">none</Typography> : (
                    <Stack spacing={0.25}>
                      {list(d.ruleSets).map((r) => (
                        <Tooltip key={r.id || r.filterText} title={r.filterText}>
                          <Typography variant="body2">{r.description || r.filterText}</Typography>
                        </Tooltip>
                      ))}
                    </Stack>
                  )}
                </TableCell>
                <TableCell>{d.connectionState || ''}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}

export default DevicesTab;
